import React, { useEffect, useState } from 'react';
import './Home.css';
import logo from '../assets/logo.png';
import banner1 from '../assets/slider/slide1.png';
import banner2 from '../assets/slider/slide2.png';
import banner3 from '../assets/slider/slide3.png';
import activity1 from '../assets/studentlife/activity1.jpg';
import activity2 from '../assets/studentlife/activity2.jpg';
import activity3 from '../assets/studentlife/activity3.jpg';
import VideoGallery from '../components/VideoGallery';
import SmoothGallerySlider from '../components/SmoothGallerySlider';
import YouTubeGalleryModal from '../components/YouTubeGalleryModal';
import BannerSlider from '../components/BannerSlider';
import AdmissionBannerWithForm from '../components/AdmissionBannerWithForm';
import AdmissionForm from '../components/AdmissionForm';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

import MainMenu from '../components/MainMenu';

const sliderImages = [banner1, banner2, banner3];

const Home = () => {
  const galleryImages = [
    "/gallery/gallery1.jpg",
    "/gallery/gallery2.jpg",
    "/gallery/gallery3.jpg",
    "/gallery/gallery4.jpg",
  ];
  
  // ✅ Add styling here
  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '15px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  };

  const submitStyle = {
    backgroundColor: '#125303',
    color: '#fff',
    padding: '12px 25px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const [currentGallery, setCurrentGallery] = useState(0);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  
  // WhatsApp Form States
  const [whatsAppForm, setWhatsAppForm] = useState({
    schoolName: '',
    studentName: '',
    location: '',
    contactNumber: '',
    studyingSchool: '',
    admissionClass: ''
  });

  useEffect(() => {
    // Show WhatsApp modal when page loads
    const timer = setTimeout(() => {
      setShowWhatsAppModal(true);
    }, 1000); // Show after 1 second

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setGalleryIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleWhatsAppChange = (e) => {
    const { name, value } = e.target;
    setWhatsAppForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();
    
    // Format the message
    const message = `*New Admission Inquiry*\n\n` +
      `*Student Name:* ${whatsAppForm.studentName}\n` +
      `*Location:* ${whatsAppForm.location}\n` +
      `*Contact Number:* ${whatsAppForm.contactNumber}\n` +
      `*Name of the school studying:* ${whatsAppForm.studyingSchool}\n` +
      `*Admission for the class:* ${whatsAppForm.admissionClass}`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // WhatsApp URL with phone number
    const whatsappURL = `https://wa.me/9025846680?text=${encodedMessage}`;
    
    // Open WhatsApp
    window.open(whatsappURL, '_blank');
    
    // Close modal
    setShowWhatsAppModal(false);
    
    // Reset form
    setWhatsAppForm({
      studentName: '',
      location: '',
      contactNumber: '',
      studyingSchool: '',
      admissionClass: ''
    });
  };

  const bannerTexts = [
    {
      title: 'Unlock Your Child\'s Potential',
      subtitle: 'Explore a nurturing and dynamic learning environment.',
    },
    {
      title: 'Admissions Open 2026–27',
      subtitle: 'Secure a brighter future at Universal Academy today.',
    },
    {
      title: 'Where Learning Comes to Life',
      subtitle: 'Innovative teaching, compassionate guidance, strong values.',
    }
  ];

  const timelineDot = {
    width: '15px',
    height: '15px',
    backgroundColor: '#007bff',
    borderRadius: '50%',
    position: 'absolute',
    left: '-8px',
    top: '5px',
  };

  const timelineContent = (side = 'left') => ({
    marginLeft: side === 'left' ? '30px' : '30px',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    maxWidth: '600px',
  });

  return (
    <div className="home-container">
      {/* WhatsApp Popup Modal */}
      {showWhatsAppModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 5px 25px rgba(0,0,0,0.2)',
            position: 'relative',
          }}>
            <button 
              onClick={() => setShowWhatsAppModal(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#666',
              }}
            >
              ✕
            </button>
            
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '24px', color: '#25D366', marginBottom: '5px' }}>
                <i className="fab fa-whatsapp"></i>
              </div>
              <h2 style={{ color: '#125303', marginBottom: '10px' }}>Admission Inquiry</h2>
              <p style={{ color: '#666', fontSize: '14px' }}>
                Fill this form to send inquiry via WhatsApp
              </p>
            </div>
            
            <form onSubmit={handleWhatsAppSubmit}>
         
              
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                  Student Name *
                </label>
                <input
                  type="text"
                  name="studentName"
                  value={whatsAppForm.studentName}
                  onChange={handleWhatsAppChange}
                  required
                  style={inputStyle}
                  placeholder="Enter student name"
                />
              </div>
              
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                  Location *
                </label>
                <input
                  type="text"
                  name="location"
                  value={whatsAppForm.location}
                  onChange={handleWhatsAppChange}
                  required
                  style={inputStyle}
                  placeholder="City, State"
                />
              </div>
              
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                  Contact Number *
                </label>
                <input
                  type="tel"
                  name="contactNumber"
                  value={whatsAppForm.contactNumber}
                  onChange={handleWhatsAppChange}
                  required
                  style={inputStyle}
                  placeholder="+91 9876543210"
                />
              </div>
              
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                  Name of the school studying *
                </label>
                <input
                  type="text"
                  name="studyingSchool"
                  value={whatsAppForm.studyingSchool}
                  onChange={handleWhatsAppChange}
                  required
                  style={inputStyle}
                  placeholder="Current school name"
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                  Admission for the class *
                </label>
                <input
                  type="text"
                  name="admissionClass"
                  value={whatsAppForm.admissionClass}
                  onChange={handleWhatsAppChange}
                  required
                  style={inputStyle}
                  placeholder="e.g., Class 6"
                />
              </div>
              
              <button 
                type="submit"
                style={{
                  ...submitStyle,
                  backgroundColor: '#25D366',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
              >
                <i className="fab fa-whatsapp"></i>
                Send via WhatsApp
              </button>
              
              <p style={{
                textAlign: 'center',
                marginTop: '15px',
                fontSize: '12px',
                color: '#666'
              }}>
                You'll be redirected to WhatsApp to send this information
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Rest of your existing code remains the same */}
      <div className="top-bar-wrapper">
        {/* Left: Ticker */}
        <div className="news-ticker">
          <div className="ticker-content">
            🎓 Admissions Open for 2026–2027 — Enroll Now at Universal Academy! 📢
          </div>
        </div>

        {/* Right: Location + Timing */}
        <div className="top-bar-info">
          <div className="top-item">
            <i className="fas fa-envelope"></i> universalacademy@gmail.com
          </div>
          <div className="top-item">
            <i className="fas fa-phone-alt"></i> 04368-221616
          </div>
          <div className="top-item">
            <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
          </div>
        </div>
      </div>

      <header className="logo-header">
        <div className="header-row">
          {/* Left: Logo */}
          <Link to="/" className="logo-area">
            <img src={logo} alt="Universal Academy Logo" />
          </Link>
          
          {/* Title below logo+info */}
          <div className="school-title">
            <h1>UNIVERSAL ACADEMY</h1>
            <p>Affiliated to CBSE – Karaikal, Puducherry</p>
          </div>
        </div>
      </header>

      <MainMenu />   
      <BannerSlider />

<section className="about-hero-block">
  <div className="container">
    <div className="about-hero-row" style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
      
      {/* Small Image on Left */}
      <div className="about-hero-image" style={{ flex: '1 1 30%' }}>
        <img src="/about-preview.png" alt="Universal Academy" style={{ width: '100%', maxWidth: '300px', borderRadius: '8px' }} />
      </div>
      
      {/* Content on Right */}
      <div className="about-hero-content" style={{ flex: '1 1 65%' }}>
        <h2>About Universal Academy</h2>
        <div className="about-divider" />
        <p className="about-tagline">
          “The Whole purpose of Education is to turn mirrors into windows”
        </p>
        <p>
          Universal Academy School Affiliated to CBSE, nestled in the beautiful town of Karaikal is an institution meant for students of all faiths. At Universal, we create a bright future for our Children.
        </p>   
		<p>
         it is a venture of Universal Foundation, a trust founded in 2013. From its inception, the journey of Universal Academy has been one of vision and growth.
        </p>
        <a href="/about" className="about-arrow-link">
          Learn More <i className="fas fa-arrow-right"></i>
        </a>
      </div>

    </div>
  </div>
</section>



	  
	   

<section className="student-life-section" style={{ padding: '60px 0 10px', backgroundColor: '#fff' }}>
  <div className="container" style={{ maxWidth: '1140px', margin: '0 auto', textAlign: 'center' }}>
    <h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>Student Life</h2>
    <p style={{ fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto 30px' }}>
      At Universal Academy, student life goes beyond the classroom. With sports, arts, clubs, and leadership programs,
      we nurture well-rounded individuals who thrive in all aspects of life.
    </p>
   
  </div>
</section>



<section className="student-highlights" style={{ backgroundColor: '#f9f9f9' }}>
        <div className="highlight-card">
          <img src={activity1} alt="Sports" />
          <h3>Sports & Fitness</h3>
          <p>From athletics to yoga, we nurture physical strength and discipline.</p>
        </div>
        <div className="highlight-card">
          <img src={activity2} alt="Clubs" />
          <h3>Clubs & Hobbies</h3>
          <p>Science, arts, reading, nature, and more — there’s a club for every passion.</p>
        </div>
        <div className="highlight-card">
          <img src={activity3} alt="Events" />
          <h3>Events & Competitions</h3>
          <p>Celebrations and challenges that inspire confidence and expression.</p>
        </div>
		
		
      </section>
	  
	  
	  <section className="student-life-section" style={{ padding: '60px 0', backgroundColor: '#fff' }}>
  <div className="container" style={{ maxWidth: '1140px', margin: '0 auto', textAlign: 'center' }}>
 
    <a href="/student-life" className="btn-student-life" style={{ padding: '10px 25px', backgroundColor: '#125303', color: '#fff', borderRadius: '5px', textDecoration: 'none' }}>
      Explore Student Life
    </a>
  </div>
</section>
<section className="hero-section split-hero">
        <div className="hero-left shape-bg">
          <h4>Welcome To</h4>
          <h1>Universal Academy</h1>
          <p>
            Founded in 2008, Universal Academy has been shaping young minds with strong values and academic excellence.
          </p>
        </div>
        <div className="hero-right simple-slider">
          <img src={sliderImages[currentSlide]} alt={`Slide ${currentSlide + 1}`} />
        </div>
      </section>
	  



<section className="mandatory-disclosure-section" style={{ padding: '60px 20px 100px', backgroundColor: '#f5f5f5' }}>
  <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
    <h2 style={{ fontSize: '1.75rem', marginBottom: '20px', color: '#222' }}>Mandatory Disclosure</h2>
    <p style={{ fontSize: '1rem', marginBottom: '30px', color: '#555' }}>
      Download important school-related documents as part of our transparency and compliance with CBSE regulations.
    </p>
    
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
      {/* PDF Link 1 */}
      <a 
        href="/pdfs/affiliation-letter.pdf" 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{
          display: 'inline-block',
          padding: '12px 20px',
          backgroundColor: '#125303',
          color: '#fff',
          borderRadius: '6px',
          textDecoration: 'none',
          fontWeight: 'bold',
          minWidth: '200px'
        }}
      >
        📄 Affiliation Letter
      </a>

      {/* PDF Link 2 */}
      <a 
        href="/pdfs/school-management-committee.pdf" 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{
          display: 'inline-block',
          padding: '12px 20px',
          backgroundColor: '#125303',
          color: '#fff',
          borderRadius: '6px',
          textDecoration: 'none',
          fontWeight: 'bold',
          minWidth: '200px'
        }}
      >
        📄 Management Committee
      </a>

      {/* PDF Link 3 */}
      <a 
        href="/pdfs/infrastructure-details.pdf" 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{
          display: 'inline-block',
          padding: '12px 20px',
          backgroundColor: '#125303',
          color: '#fff',
          borderRadius: '6px',
          textDecoration: 'none',
          fontWeight: 'bold',
          minWidth: '200px'
        }}
      >
        📄 Infrastructure Details
      </a>
    </div>
  </div>
</section>


<AdmissionBannerWithForm />


<section className="laboratory-section" style={{ padding: '60px 20px', backgroundColor: '#e9f5ec' }}>
  <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
    <h2 style={{ fontSize: '1.75rem', marginBottom: '20px', color: '#125303' }}>Laboratory Facilities</h2>
    <p style={{ fontSize: '1.1rem', marginBottom: '30px', color: '#333' }}>
      Universal Academy boasts state-of-the-art laboratories that foster experiential learning through hands-on experiments.
      Our labs are well-equipped for Physics, Chemistry, Biology, and Computer Science, promoting scientific temper in students.
    </p>

    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '30px',
      marginTop: '40px'
    }}>
      {/* Physics Lab */}
      <div style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '200px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.06)'
      }}>
        <img src="/labs/1.png" alt="Physics Lab" style={{ width: '100%', borderRadius: '6px', marginBottom: '15px' }} />
        <h3 style={{ color: '#125303' }}>Physics Lab</h3>
        <p>Precision instruments and experimental setups for young physicists.</p>
      </div>

      {/* Chemistry Lab */}
      <div style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '200px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.06)'
      }}>
        <img src="/labs/2.png" alt="Chemistry Lab" style={{ width: '100%', borderRadius: '6px', marginBottom: '15px' }} />
        <h3 style={{ color: '#125303' }}>Chemistry Lab</h3>
        <p>Safe and modern lab facilities for exciting chemical experiments.</p>
      </div>

      {/* Biology Lab */}
      <div style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '200px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.06)'
      }}>
        <img src="/labs/3.png" alt="Biology Lab" style={{ width: '100%', borderRadius: '6px', marginBottom: '15px' }} />
        <h3 style={{ color: '#125303' }}>Biology Lab</h3>
        <p>Well-stocked with specimens, models, and microscopes for discovery.</p>
      </div>
	  {/* Biology Lab */}
      <div style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '200px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.06)'
      }}>
        <img src="/labs/4.png" alt="Biology Lab" style={{ width: '100%', borderRadius: '6px', marginBottom: '15px' }} />
        <h3 style={{ color: '#125303' }}>Mathematics Lab</h3>
        <p>Well-stocked with specimens, models, and microscopes for discovery.</p>
      </div>
    </div>

    <div style={{ marginTop: '40px' }}>
      <a href="/laboratory" style={{
        backgroundColor: '#125303',
        color: '#fff',
        padding: '12px 30px',
        borderRadius: '6px',
        textDecoration: 'none',
        fontWeight: 'bold'
      }}>
        Explore Our Laboratories
      </a>
    </div>
  </div>
</section>





<section className="events-section" style={{ padding: '60px 20px', background: 'linear-gradient(135deg, #f2f8f2, #e6f1ec)' }}>
  <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
    <h2 style={{ fontSize: '1.75rem', color: '#125303', marginBottom: '40px' }}> Upcoming Events</h2>

    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '30px'
    }}>
      {[
        { date: 'Jul 15', title: 'Foundress Day – Holiday' },
        { date: 'Aug 09', title: 'Quit India Movement Day' },
        { date: 'Aug 15', title: 'Independence Day – Public Holiday' },
      ].map((event, idx) => (
        <div key={idx} style={{
          backgroundColor: '#fff',
          borderRadius: '10px',
          padding: '20px',
          width: '280px',
          boxShadow: '0 8px 16px rgba(0,0,0,0.07)',
          transition: 'transform 0.3s ease',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px',
            color: '#125303',
            fontSize: '2rem'
          }}>
            <i className="fas fa-calendar-day"></i>
          </div>
          <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>
            {event.title}
          </div>
          <div style={{
            backgroundColor: '#125303',
            color: '#fff',
            padding: '8px 14px',
            borderRadius: '20px',
            display: 'inline-block',
            fontSize: '0.9rem'
          }}>
            {event.date}
          </div>
        </div>
      ))}
    </div>

    <div style={{ marginTop: '40px' }}>
      <a href="/events" style={{
        padding: '12px 25px',
        backgroundColor: '#125303',
        color: '#fff',
        borderRadius: '6px',
        textDecoration: 'none',
        fontWeight: 'bold',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
      }}>
        View All Events →
      </a>
    </div>
  </div>
</section>




<VideoGallery />

<section className="google-reviews-section" style={{ padding: '80px 20px', background: 'linear-gradient(to right, #f0f8f0, #eaf4ed)' }}>
  <div style={{ maxWidth: '1150px', margin: '0 auto' }}>
    <div style={{ textAlign: 'center', marginBottom: '50px' }}>
      <h2 style={{ fontSize: '1.75rem', color: '#125303', marginBottom: '10px' }}> Our Location</h2>
      <p style={{ fontSize: '1.1rem', color: '#444' }}>
        Hear from students and parents about their experience with Universal Academy.
      </p>
    </div>

    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'stretch',
      justifyContent: 'center',
      gap: '30px',
    }}>
      {/* Info + Rating Card */}
      <div style={{
        flex: '1 1 350px',
        background: '#fff',
        padding: '30px',
        borderRadius: '15px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
      }}>
        <h3 style={{ color: '#125303', fontSize: '1.5rem', marginBottom: '10px' }}>Universal Academy, Karaikal</h3>
        <div style={{ fontSize: '2rem', color: '#fbbf24', marginBottom: '8px' }}>★★★★★</div>
        <p style={{ fontSize: '1rem', color: '#555', marginBottom: '20px' }}>
          Rated 4.8/5 by over 100+ happy parents and students.
        </p>
        <a href="https://g.co/kgs/9rVEMQc" target="_blank" rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            backgroundColor: '#125303',
            color: '#fff',
            padding: '12px 25px',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: 'bold',
            boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
          }}>
          Read More Reviews
        </a>
      </div>

      {/* Embedded Google Map with Review Badge */}
      <div style={{
        flex: '1 1 600px',
        borderRadius: '15px',
        overflow: 'hidden',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        minHeight: '450px',
      }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.0179756866255!2d79.82828017586951!3d10.88623705715695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5513f63e461ced%3A0x9db99ae4ae010e81!2sUniversal%20Acadamy%2CNeravi%2CKaraikal!5e0!3m2!1sen!2sin!4v1750824968377!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Universal Academy Reviews"
        ></iframe>
      </div>
    </div>
  </div>
</section>

<YouTubeGalleryModal />


<section className="google-reviews-section" style={{ padding: '60px 20px', backgroundColor: '#f8f8f8' }}>
  <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
    <h2 style={{ fontSize: '1.75rem', marginBottom: '10px', color: '#125303' }}>Google Reviews</h2>
    <p style={{ fontSize: '1.1rem', marginBottom: '40px', color: '#555' }}>
      Here's what students and parents are saying about Universal Academy.
    </p>

    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '30px',
    }}>
      {[
        {
          name: 'Anjali R.',
          stars: 5,
          comment: 'Amazing school with caring staff and great academics.',
          avatar: '/avatars/user1.png',
        },
        {
          name: 'Rajesh Kumar',
          stars: 4,
          comment: 'Very good environment for children. Highly recommended.',
          avatar: '/avatars/user2.png',
        },
        {
          name: 'Meera S.',
          stars: 5,
          comment: 'My kids love the activities and teachers here!',
          avatar: '/avatars/user3.png',
        },
      ].map((review, index) => (
        <div key={index} style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '12px',
          boxShadow: '0 6px 12px rgba(0,0,0,0.06)',
          textAlign: 'left',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
            <img
              src={review.avatar}
              alt={review.name}
              style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '15px' }}
            />
            <div>
              <strong style={{ fontSize: '1rem', color: '#333' }}>{review.name}</strong>
              <div style={{ color: '#f5a623', fontSize: '1.2rem' }}>
                {'★'.repeat(review.stars)}{'☆'.repeat(5 - review.stars)}
              </div>
            </div>
          </div>
          <p style={{ fontSize: '0.95rem', color: '#555' }}>{review.comment}</p>
        </div>
      ))}
    </div>

    <div style={{ marginTop: '40px' }}>
      <a
        href="https://g.co/kgs/9rVEMQc" // Your real Google shortlink
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#125303',
          color: '#fff',
          padding: '12px 25px',
          borderRadius: '6px',
          textDecoration: 'none',
          fontWeight: 'bold',
        }}
      >
        Read More Reviews on Google
      </a>
    </div>
  </div>
</section>




	  
	   <div className="floating-buttons">
        <a href="tel:+919486310015" className="call-btn" title="Call">
          <i className="fas fa-phone-alt"></i>
        </a>
        <a
          href="https://wa.me/919486310015"
          target="_blank"
          rel="noreferrer"
          className="whatsapp-btn"
          title="WhatsApp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
	  
<Footer /> 


    {showForm && <AdmissionForm />(
  <div style={{
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  }}>
    <div style={{
      backgroundColor: '#fff',
      padding: '30px',
      borderRadius: '10px',
      maxWidth: '500px',
      width: '100%',
      position: 'relative',
    }}>
      <h2 style={{ marginBottom: '20px', color: '#125303' }}>Admission Application Form</h2>
      <form
        action="https://formspree.io/f/your_form_id"  // 🔁 Replace with your real Formspree form ID
        method="POST"
      >
        <input type="text" name="name" placeholder="Full Name" required style={inputStyle} />
        <input type="email" name="email" placeholder="Email Address" required style={inputStyle} />
        <input type="tel" name="phone" placeholder="Phone Number" required style={inputStyle} />
        <input type="text" name="class" placeholder="Class Applying For" required style={inputStyle} />
        <button type="submit" style={submitStyle}>Submit</button>
      </form>
      <button onClick={() => setShowForm(false)} style={{
        position: 'absolute', top: '10px', right: '15px', fontSize: '18px', background: 'none',
        border: 'none', cursor: 'pointer'
      }}>✕</button>
    </div>
  </div>
)}

      
    </div>
  );
};

export default Home;